import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../common/SEO';
import Layout from '../common/Layout';
import LegalPage from '../components/ui/LegalPage';
import Notice from '../components/ui/Notice';
import DlFacts from '../components/ui/DlFacts';
import { entity } from '../content/en';

const Terms = () => {
  const { t } = useTranslation('cy');
  const meta = t('terms.meta', { returnObjects: true });

  const sections = [
    { id: 'terms-site-use', title: t('terms.siteUse.h2') },
    { id: 'terms-investment-boundary', title: t('terms.boundary.h2') },
    { id: 'terms-information-risk', title: t('terms.infoRisk.h2') },
    { id: 'terms-submissions', title: t('terms.submissions.h2') },
    { id: 'terms-intellectual-property', title: t('terms.intellectualProperty.h2') },
    { id: 'terms-third-parties', title: t('terms.thirdParties.h2') },
    { id: 'terms-liability', title: t('terms.liability.h2') },
    { id: 'terms-law-contact', title: t('terms.lawContact.h2') },
  ];

  return (
    <Layout>
      <SEO title={meta.title} description={meta.description} path="/terms" />

      <LegalPage
        id="terms-header"
        eyebrow={t('terms.header.eyebrow')}
        title={t('terms.header.h1')}
        metaBlock={
          <DlFacts
            rows={[
              { label: t('ui.labels.entity'), value: entity.name },
              { label: t('ui.labels.effective'), value: t('terms.header.effective') },
            ]}
          />
        }
        summary={t('terms.header.acceptance')}
        sections={sections}
      >
        <Notice variant="compliance" style={{ marginBottom: 24 }}>{t('terms.header.notice')}</Notice>
        <p style={{ fontSize: 'var(--cy-size-body)', lineHeight: 1.75, color: 'var(--cy-color-text-secondary)' }}>
          {t('terms.header.scope')}
        </p>

        <section id="terms-site-use">
          <h2>{t('terms.siteUse.h2')}</h2>
          <p>{t('terms.siteUse.allowed')}</p>
          <p>{t('terms.siteUse.prohibited')}</p>
          <p>{t('terms.siteUse.availability')}</p>
        </section>

        <section id="terms-investment-boundary">
          <h2>{t('terms.boundary.h2')}</h2>
          <Notice variant="compliance" style={{ marginBottom: 24 }}>
            {t('terms.boundary.conclusion')}
          </Notice>
          <p>{t('terms.boundary.licence')}</p>
          <p>{t('terms.boundary.supplement')}</p>
          <p style={{ marginTop: 16 }}>
            <Link className="cy-link" to="/approach#approach-risk">{t('terms.boundary.riskLink')}</Link>
          </p>
        </section>

        <section id="terms-information-risk">
          <h2>{t('terms.infoRisk.h2')}</h2>
          <ul style={{ listStyle: 'disc', paddingLeft: 20 }}>
            {t('terms.infoRisk.points', { returnObjects: true }).map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </section>

        <section id="terms-submissions">
          <h2>{t('terms.submissions.h2')}</h2>
          <Notice variant="compliance" style={{ marginBottom: 24 }}>
            {t('terms.submissions.warning')}
          </Notice>
          <ul style={{ listStyle: 'disc', paddingLeft: 20 }}>
            {t('terms.submissions.points', { returnObjects: true }).map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
          <p style={{ marginTop: 16 }}>
            <Link className="cy-link" to="/privacy">{t('terms.submissions.privacyLink')}</Link>
          </p>
        </section>

        <section id="terms-intellectual-property">
          <h2>{t('terms.intellectualProperty.h2')}</h2>
          <p>{t('terms.intellectualProperty.site')}</p>
          <p>{t('terms.intellectualProperty.licence')}</p>
          <p>{t('terms.intellectualProperty.thirdParty')}</p>
          <p>{t('terms.intellectualProperty.submitted')}</p>
        </section>

        <section id="terms-third-parties">
          <h2>{t('terms.thirdParties.h2')}</h2>
          <ul style={{ listStyle: 'disc', paddingLeft: 20 }}>
            {t('terms.thirdParties.points', { returnObjects: true }).map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </section>

        <section id="terms-liability">
          <h2>{t('terms.liability.h2')}</h2>
          <ul style={{ listStyle: 'disc', paddingLeft: 20 }}>
            {t('terms.liability.points', { returnObjects: true }).map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </section>

        <section id="terms-law-contact">
          <h2>{t('terms.lawContact.h2')}</h2>
          <p>{t('terms.lawContact.law')}</p>
          <p>{t('terms.lawContact.updates')}</p>
          <p>{t('terms.lawContact.contact')}</p>
          <p>{t('terms.lawContact.severability')}</p>
          <p style={{ marginTop: 16 }}>
            <Link className="cy-link" to="/contact">{t('nav.contact')}</Link>
          </p>
        </section>
      </LegalPage>
    </Layout>
  );
};

export default Terms;
